import React from 'react';

import Skeleton from '@atlaskit/skeleton';

export const DefaultActionRendererSkeleton = (): React.JSX.Element => {
	return <Skeleton width="200px" height="80px" />;
};
